var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FCFCFD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 19.2591H10.9294C10.4794 19.2591 10.1094 18.8891 10.1094 18.4391C10.1094 17.9891 10.4794 17.6191 10.9294 17.6191H19.9994C20.4494 17.6191 20.8194 17.9891 20.8194 18.4391C20.8194 18.8991 20.4494 19.2591 19.9994 19.2591Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 12.9701H10.9294C10.4794 12.9701 10.1094 12.6001 10.1094 12.1501C10.1094 11.7001 10.4794 11.3301 10.9294 11.3301H19.9994C20.4494 11.3301 20.8194 11.7001 20.8194 12.1501C20.8194 12.6001 20.4494 12.9701 19.9994 12.9701Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 6.6693H10.9294C10.4794 6.6693 10.1094 6.2993 10.1094 5.8493C10.1094 5.3993 10.4794 5.0293 10.9294 5.0293H19.9994C20.4494 5.0293 20.8194 5.3993 20.8194 5.8493C20.8194 6.2993 20.4494 6.6693 19.9994 6.6693Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.90969 8.02992C4.68969 8.02992 4.47969 7.93992 4.32969 7.78992L3.41969 6.87992C3.09969 6.55992 3.09969 6.03992 3.41969 5.71992C3.73969 5.39992 4.25969 5.39992 4.57969 5.71992L4.90969 6.04992L7.04969 3.90992C7.36969 3.58992 7.88969 3.58992 8.20969 3.90992C8.52969 4.22992 8.52969 4.74992 8.20969 5.06992L5.48969 7.78992C5.32969 7.93992 5.12969 8.02992 4.90969 8.02992Z",
    fill: "#FCFCFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.90969 14.3307C4.69969 14.3307 4.48969 14.2507 4.32969 14.0907L3.41969 13.1807C3.09969 12.8607 3.09969 12.3407 3.41969 12.0207C3.73969 11.7007 4.25969 11.7007 4.57969 12.0207L4.90969 12.3507L7.04969 10.2107C7.36969 9.8907 7.88969 9.8907 8.20969 10.2107C8.52969 10.5307 8.52969 11.0507 8.20969 11.3707L5.48969 14.0907C5.32969 14.2507 5.11969 14.3307 4.90969 14.3307Z",
    fill: "#FCFCFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.90969 20.3307C4.69969 20.3307 4.48969 20.2507 4.32969 20.0907L3.41969 19.1807C3.09969 18.8607 3.09969 18.3407 3.41969 18.0207C3.73969 17.7007 4.25969 17.7007 4.57969 18.0207L4.90969 18.3507L7.04969 16.2107C7.36969 15.8907 7.88969 15.8907 8.20969 16.2107C8.52969 16.5307 8.52969 17.0507 8.20969 17.3707L5.48969 20.0907C5.32969 20.2507 5.11969 20.3307 4.90969 20.3307Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManagement);
export default __webpack_public_path__ + "static/media/task-management.ba74e6bd8f109676368de0962b64f7c4.svg";
export { ForwardRef as ReactComponent };